import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { AdUnitForProductTableDTO } from './types'

export const AD_UNIT_FOR_PRODUCT_TABLE_FRAGMENT = (
  ability: Ability,
): TypedDocumentNode<AdUnitForProductTableDTO> => gql`
  ${ALERT_FRAGMENT}

  fragment AdUnitForProductTableFragment on AdUnit {
    ${permitFields<AdUnitForProductTableDTO>({
      ybAdUnitEnabled: ability.can('read', 'AdUnitField-ybAdUnitEnabled'),
    })}

    divId
    fieldAlerts {
      ...AlertFragment
    }
    id
    name
    outOfPage
    path
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
